import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEscape);
    }
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-204">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-navy-900/90 backdrop-blur-sm z-50" data-id="element-205" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-206">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2,
          ease: 'easeOut'
        }} className="bg-cream-50 rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden pointer-events-auto" data-id="element-207">
              {/* Header */}
              <div className="sticky top-0 bg-cream-50 border-b border-cream-200 px-6 py-4 flex items-center justify-between z-10" data-id="element-208">
                <h2 className="text-2xl font-serif text-navy-900" data-id="element-209">{title}</h2>
                <button onClick={onClose} className="p-2 hover:bg-cream-100 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-gold-500" aria-label="Close modal" data-id="element-210">
                  <XIcon className="w-5 h-5 text-navy-700" data-id="element-211" />
                </button>
              </div>

              {/* Content */}
              <div className="px-6 py-8 overflow-y-auto max-h-[calc(85vh-80px)] text-navy-800" data-id="element-212">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}